import type { OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'
import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'
import useSuggestedPackageOptionFromApi from './useSuggestedPackageOptionFromApi'
import useSuggestedPackageOptionFromTotalSales from './useSuggestedPackageOptionFromTotalSales'

interface Params {
  room?: OfferPageRoom
}

interface SuggestedPackageResult {
  option: App.OfferPackageOptionView
  message: string
}

function useSuggestedPackageOption({ room }: Params = {}): SuggestedPackageResult | undefined {
  const { isAnyVariant } = useExperiment(Experiments.croPackageRecommendationApi)

  const apiResult = useSuggestedPackageOptionFromApi({ room, enabled: isAnyVariant })
  const totalSalesResult = useSuggestedPackageOptionFromTotalSales({ room })

  return isAnyVariant ? apiResult : totalSalesResult
}

export default useSuggestedPackageOption
